import {batch} from 'react-redux';
import * as actiontypes from '../../constants/actionType';

export function selectTipColumnIdx(column) {
  return {type: actiontypes.SELECT_TIP_COLUMN, column};
}

export function deselectTipColumnIdx(column) {
  return (dispatch, getState) => {
    const {tipState} = getState();
    const {selectedColumns} = tipState;
    const columnId = selectedColumns.indexOf(column);
    dispatch({type: actiontypes.DESELECT_TIP_COLUMN, columnId});
  };
}

export function setTipAmount(amount) {
  return {type: actiontypes.SET_TIP_AMOUNT, amount};
}

export function setSelectedTipColumn(columns) {
  return {type: actiontypes.SET_SELECTED_TIP_COLUMN, selectedColumns: columns};
}

export function setSelectedTipQuadrant(quadrants) {
  return {type: actiontypes.SET_SELECTED_TIP_QUADRANT, selectedQuadrants: quadrants};
}

export function setTipState(amount, selectedColumns, selectedRows, selectedQuadrants) {
  return {
    type: actiontypes.SET_TIP_STATE,
    selectedQuadrants,
    selectedColumns,
    selectedRows,
    amount,
  };
}

export function selectTipQuadrant(quadrant) {
  return {type: actiontypes.SELECT_TIP_QUADRANT, quadrant};
}

export function deselectTipQuadrant(quadrant) {
  return (dispatch, getState) => {
    const {tipState} = getState();
    const {selectedQuadrants} = tipState;
    const quadrantId = selectedQuadrants.indexOf(quadrant);
    dispatch({type: actiontypes.DESELECT_TIP_QUADRANT, quadrantId});
  };
}

export function resetTipState() {
  return {type: actiontypes.RESET_TIP_SELECTION};
}

export function setPrevSelectedTip(prevSelectedTip) {
  return {type: actiontypes.SET_PREV_SELECTED_TIP, prevSelectedTip};
}

export function setAlreadyUndo(isAlreadyUndo) {
  return {type: actiontypes.SET_IS_ALREADY_UNDO, isAlreadyUndo};
}

export function setSelectedTip(selectedTip, isUndo = false) {
  return (dispatch, getState) => {
    const {tipState} = getState();
    batch(() => {
      if (tipState.isAlreadyUndo && !isUndo) dispatch(setAlreadyUndo(false));
      dispatch(setPrevSelectedTip(tipState.selectedTip));
      dispatch({type: actiontypes.SET_SELECTED_TIP, selectedTip});
    });
  };
}

export function restoreTipState(state) {
  return {type: actiontypes.RESTORE_TIP_STATE, state};
}

export function setShowSetTipModal(isShow) {
  return {type: actiontypes.SET_SHOW_SET_TIP_MODAL, isShow};
}

export function setPrevErrorCodeSetTipModal(errorCode) {
  return {type: actiontypes.SET_PREV_ERROR_SET_TIP_MODAL, errorCode};
}
